export default __webpack_public_path__ + "static/media/Proxima Nova Font.7bc9ce40.otf";